import './App.scss';
import {useLocation , Navigate} from "react-router-dom";
import {Route, Routes} from 'react-router';
import Header from "./components/Header/Header";
import Home from "./pages/Home";
import Seasons from "./pages/Seasons";
import Season from "./pages/Season";
import Page from "./pages/Page";
import { QueryClient, QueryClientProvider } from 'react-query';
import {ReactQueryDevtools} from "react-query/devtools";
import Posts from "./pages/Posts";
import SkinVote from "./pages/SkinVote";
import TeamsPage from "./pages/TeamsPage";
import Team from "./pages/Team";
import LateGroup from "./pages/LateGroup";
import {CSSTransition, TransitionGroup} from "react-transition-group";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Profile from "./pages/Profile";
import {ErrorProvider, useError} from "./context/ErrorContext";
import {LoadingProvider} from "./context/LoadingContext";
import {useEffect} from "react";
import {setupAxiosInterceptors} from "./axios/api-config";
import Error from "./pages/Error";
import NotFound from "./pages/NotFound";
import {LoggedUserProvider} from "./context/LoggedUserContext";
import ProfileEdit from "./pages/ProfileEdit";
import {Toaster} from "react-hot-toast";
import Loading from "./components/Loading/Loading";
import PrivacyPolicy from "./components/Page/PrivacyPolicy";

export const queryClient = new QueryClient();

function App() {
    const loc = useLocation();
    const { error, setError } = useError();

    useEffect(() => {
        setupAxiosInterceptors(setError);
    }, [setError]);

    const hideHeaderRoutes = ["/home", '/']; // Add more paths to hide the header
    const shouldHideHeader = hideHeaderRoutes.includes(loc.pathname);

    return (
        <>
            {!shouldHideHeader && <Header />}
            {!error && <TransitionGroup component={null}>
                    <Toaster position="top-right" toastOptions={{className: 'toaster'}}/>
                    <Loading />
                 <CSSTransition key={loc.pathname} classNames="anim" timeout={200}>
                        <main>
                            <Routes location={loc}>
                                <Route path="/" element={<Navigate to="/home" replace />} />
                                <Route path="/home" element={<Home />} />
                                <Route path="/posts" element={<Posts />} />
                                <Route path="/seasons" element={<Seasons />} />
                                <Route path="/season/:slug" element={<Season />} />
                                <Route path="/skin-vote" element={<SkinVote />} />
                                <Route path="/teams" element={<TeamsPage />} />
                                <Route path="/teams/:slug" element={<Team />} />
                                <Route path="/page/:slug" element={<Page />} />
                                <Route path="/late-group" element={<LateGroup />} />
                                <Route path="/profile/edit" element={<ProfileEdit />} />
                                <Route path="/profile/:username" element={<Profile />} />
                                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                                <Route path="*" element={<NotFound setError={setError} />} />
                            </Routes>
                        </main>
                    </CSSTransition>
                </TransitionGroup>
            }
            {error &&
                <Error error={error} />
            }
        </>

    );
}

const root = document.documentElement;
root.style.setProperty('--current-url', `'${window.location.href}'`);

export default function RootApp() {
    return (
        <QueryClientProvider client={queryClient}>
            <LoadingProvider>
                <ErrorProvider>
                    <LoggedUserProvider>
                        <App />
                    </LoggedUserProvider>
                </ErrorProvider>
            </LoadingProvider>
            <ReactQueryDevtools initialIsOpen />
        </QueryClientProvider>
    );
}
